import React from 'react'
import SimpleTooltip from 'shared/components/SimpleToolTip'
import styled from 'styled-components'

const ExplanationBullet = ({ children, ...props }) => (
  <SimpleTooltip placement="right" text={children}>
    <ExplanationInnerBullet {...props}>?</ExplanationInnerBullet>
  </SimpleTooltip>
)

const ExplanationInnerBullet = styled.span`
  background-color: #ccc;
  border-radius: 50%;
  color: white;
  font-size: 9px;
  padding: 2px 4px 1px 4px;
  position: relative;
  top: -1px;
`

export default ExplanationBullet
